import { z } from "zod";


export const LocationResponseSchema = z.object({
  id: z.number(),
  latitude: z.number(),
  longitude: z.number(),
  city: z.string().nullable()
});

export const SendLocationRequestSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  city: z.string().nullable().optional()
});


